import {Injectable} from '@angular/core';
import {TransactionApi} from '../../api/transaction/transaction.api.class';
import {Observable} from 'rxjs';
import {ProcessPaymentBody, State} from 'src/app/interfaces/charge-request';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(private transactionApi: TransactionApi) { }

  putTransactionStatus(transactionId: string, body: State): Observable<Object> {
    return this.transactionApi.updateTransactionStatus(transactionId, body);
  }

  // getPaymentOptions(data: Session): Observable<OptionsResponse> {
  //   return this.transactionApi.getPaymentOptions(data);
  // }

  getTransactionStatus(originatingTransactionId): Observable<any> {
    return this.transactionApi.getTransactionStatus(originatingTransactionId);
  }

  getTransactionStatusCard(sessionToken: string): Observable<any> {
    return this.transactionApi.getTransactionStatusCard(sessionToken);
  }

  postPaymentData(body: ProcessPaymentBody): Observable<any> {
    return this.transactionApi.postPaymentData(body);
  }

  postPaymentStatus(body: Object): Observable<any> {
    return this.transactionApi.postPaymentStatus(body);
  }

}
